import React, { ComponentPropsWithoutRef } from 'react';
import { PulseCheckVerticalLogo } from '../../img/PulseCheckVerticalLogo';
import { logoAnimationVariants } from '../../../BeFi20/BeFi20.meta';
import { Header } from '../../../BeFi20/Survey/components/StartPage/StartPage.styles';
import { StyledWrapper } from './StepWrapper.styles';

interface Props extends ComponentPropsWithoutRef<'div'> {
  as?: React.ElementType;
  children: React.ReactNode;
}

export const StepWrapper = ({ children, ...rest }: Props) => {
  return (
    <StyledWrapper {...rest}>
      <Header
        variants={logoAnimationVariants}
        initial="enter"
        animate="visible"
        style={{ marginTop: 90 }}
      >
        <PulseCheckVerticalLogo />
      </Header>

      {children}
    </StyledWrapper>
  );
};
